/**
 * パスワードのポリシー検証（クライアント側）。
 *
 * 正は API の `lib/security.py`（`PASSWORD_MIN_LENGTH` / `PASSWORD_MAX_BYTES` と
 * `validate_password`）で、ここはその写し。サーバも同じ検証をするので、ここを
 * 通らなくても不正な値は保存されない。それでも持つのは、**送信して 400 を見る前に
 * 要件を伝える**ため（要件を知らずに何度も弾かれるのを避ける）。
 *
 * 文言はサーバと同じにしてある。片方だけ直すとメッセージが食い違うので、
 * 変更するときは両方を揃えること。
 */

/** 最小文字数。 */
export const PASSWORD_MIN_LENGTH = 8;

/**
 * 最大バイト数。bcrypt が 72 バイトを超える入力を受け付けないため、文字数ではなく
 * バイト数で見る（全角は 1 文字 3 バイト）。
 */
export const PASSWORD_MAX_BYTES = 72;

/** 入力欄に出す要件の説明（画面間で文言を揃えるためここに置く）。 */
export const PASSWORD_REQUIREMENT_TEXT =
  "8 文字以上で、英字・数字・記号をそれぞれ 1 文字以上含めてください。";

const HAS_LETTER = /[A-Za-z]/;
const HAS_DIGIT = /[0-9]/;
// 英数字・空白以外を記号とみなす（サーバの _HAS_SYMBOL と同じ）。
const HAS_SYMBOL = /[^A-Za-z0-9\s]/;

/**
 * ポリシー違反の理由を返す。満たしていれば null。
 */
export function passwordPolicyError(password: string): string | null {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `パスワードは ${PASSWORD_MIN_LENGTH} 文字以上で入力してください。`;
  }
  if (new TextEncoder().encode(password).length > PASSWORD_MAX_BYTES) {
    return `パスワードが長すぎます（半角 ${PASSWORD_MAX_BYTES} 文字、全角 ${Math.floor(
      PASSWORD_MAX_BYTES / 3,
    )} 文字が上限です）。`;
  }
  if (
    !HAS_LETTER.test(password) ||
    !HAS_DIGIT.test(password) ||
    !HAS_SYMBOL.test(password)
  ) {
    return "パスワードは英字・数字・記号をそれぞれ1文字以上含めてください。";
  }
  return null;
}
